module.exports = __webpack_public_path__ + "static/media/mps1_v4.13335807.jpg";